module.exports = __webpack_public_path__ + "static/media/leafycode-team.185e1976.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leafycode-team.svg
// module id = 173
// module chunks = 0